// Lista la tabla de familias/Subfamlias
import React, { Fragment, useEffect } from 'react'
import DeleteBtn from '../../buttons/DeleteBtn'
import NullMssg from '../../common/NullMssg'
import { NoInfo } from '../../common/NoInfo'
import EditBtn from '../../buttons/EditBtn'
import Spinner from '../../common/Spinner'
import { mssgs } from '../../../constantes/mssgs'

/**
 * Recuento de la cabecera. Los tres datos son distintos y los tres importan:
 *
 *   411 famílias · 12 coincidencias · mostrando 8
 *    │              │                  └ cuántas hay cargadas ahora mismo
 *    │              └ cuántas casan con la búsqueda
 *    └ cuántas hay en total, el universo sobre el que se busca
 *
 * Todo es opcional. El motor antiguo no conoce ninguno de esos números, así
 * que sin ellos se muestra exactamente el texto de siempre.
 */
const textoRecuento = (cargados, total, totalGeneral, filtrando, sustantivo) => {
  if (total === undefined || total === null) return `${cargados} resultados.`

  const partes = [
    totalGeneral !== undefined && totalGeneral !== null
      ? `${totalGeneral} ${sustantivo}`
      : null,
    filtrando ? `${total} coincidencias` : null,
    cargados < total ? `mostrando ${cargados}` : null,
  ].filter(Boolean)

  return partes.length ? partes.join(' · ') : `${total} resultados.`
}

const FolderProductsTable = ({
  handleRemove,
  foldersProducts,
  toEditArticle,
  userProfile,
  loading,
  total,
  totalGeneral,
  filtrando,
}) => {
  useEffect(() => {}, [foldersProducts])

  return (
    <>
      <div
        className='products__title__container mb-30'
        style={{ display: 'flex', justifyContent: 'space-between' }}
      >
        <h3 className='products__title'>Famílias / Subfamílias Productos</h3>
        <span className='products__title__count-results'>
          {textoRecuento(
            foldersProducts?.length,
            total,
            totalGeneral,
            filtrando,
            'famílias',
          )}
        </span>
      </div>
      <Fragment>
        <table>
          <thead>
            <tr>
              <th className="table-th-code">
                Referencia
              </th>
              <th>
                Nombre
              </th>
              <th>
                Família perteneciente
              </th>
              <th>
                Subfamílias descendientes
              </th>
              <th className="table-th-doccount">
                Port.
              </th>
              <th className="table-th-doccount">
                Imgs.
              </th>
              <th className="table-th-doccount">
                Docs.
              </th>
              <th className="table-th-actions" style={{ width: '120px', minWidth: '120px' }}>
                Acciones
              </th>
            </tr>
          </thead>
          <tbody>
            {foldersProducts.length > 0 ? (
              foldersProducts.map((product, i) => (
                <tr key={i}>
                  <td className="table-td-header">
                      {product.referencia
                        ? product.referencia
                        : NoInfo('Sin ref.')}
                  </td>
                  <td className="table-td-header">
                    {product.nombre}
                  </td>
                  <td>
                    {product.nombreFamiliaProducto}
                  </td>
                  <td>
                    <div className='products__text-type scroll-wrap'>
                      {product.nombreSubFamiliaProductos.length > 0
                        ? product.nombreSubFamiliaProductos.map((x, i) => (
                            <p key={i}> {x} </p>
                          ))
                        : NoInfo('No hay subfamílias')}
                    </div>
                  </td>
                  <td
                    className="table-td-doccount"
                    title={product?.cover ? `Portada:\n\n\t${product?.cover}\n.` : undefined}
                  >
                      {product.coverCount > 0 ? product.coverCount : ''}
                  </td>
                  <td
                    className="table-td-doccount"
                    title={product?.images?.length > 0 ? `Documentos:\n\n ${product?.images?.map((img) => "\t * " + img).join('\n')}\n.` : undefined}
                  >
                      {product.imageCount > 0 ? product.imageCount : ''}
                  </td>
                  <td
                    className="table-td-doccount"
                    title={product?.documents?.length > 0 ? `Documentos:\n\n ${product?.documents?.map((doc) => "\t * " + doc).join('\n')}\n.` : undefined}
                  >
                      {product.documentCount > 0 ? product.documentCount : ''}
                  </td>
                  <td className="table-td-actions">
                    <button
                      onClick={() => toEditArticle(product.id_Articulo)}
                    >
                      <EditBtn />
                    </button>
                    <button
                      onClick={() => handleRemove(product.id_Articulo)}
                    >
                      <DeleteBtn />
                    </button>
                  </td>
                </tr>
              ))
            ) : (
              // colSpan debe coincidir con el número de <th> de arriba (8).
              // Y el <td> tiene que ir dentro de un <tr>: colgándolo de
              // <tbody> el HTML es inválido y el navegador lo recoloca, que
              // es por lo que no quedaba centrado.
              <tr>
                <td colSpan={8} style={{ textAlign: 'center', padding: '28px 0' }}>
                  {loading ? (
                    <Spinner bloque />
                  ) : (
                    <NullMssg mssg={mssgs.NADA_QUE_MOSTRAR_AÑADIR_PRODUCTOS} />
                  )}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </Fragment>
    </>
  )
}

export default FolderProductsTable
